app.directive('uiDate', [function() {

	function padLeft(value, n, str){
		value = parseFloat(value);
	    return Array(n-String(value).length+1).join(str||'0')+value;
	}

	return {
		require: 'ngModel',
		link: function($scope, element, attrs, modelCtrl) {

			function constraintInput(value) {
				return (value+'').replace(/[^\d\.\-\/ ]/g, '');
			}

			function parseInput(value) {
				value = constraintInput(value).replace(/[\D]/g, ' ').replace(/ +/g, '-').replace(/^-|-$/g, '');

				if (/^\d{8}$/.test(value)) {
					value = value.substr(0, 2) +'-'+ value.substr(2, 2) +'-'+ value.substr(4, 4);
				}

				var parts = value.split('-');
				if (parts.length < 3) return null;

				var year = parseInt(parts[2], 10);
				var month = parseInt(parts[1], 10);
				var day = parseInt(parts[0], 10);

				if (year <= 1880 || year > (new Date()).getFullYear() + 100) return null;
				if (month < 1 || month > 12) return null;
				if (day < 1 || day > 31) return null;

				return padLeft(year, 4) +'-'+ padLeft(month, 2) +'-'+ padLeft(day, 2);
			}

			function formatValue(value) {
				var parts = (''+value).split('-');
				if (parts.length < 3) return null;
				return parts[2] +'-'+ parts[1] +'-'+ parts[0];
			}

			function formatter(value) {
				return formatValue( value );
			}

			function parser(value) {

				var cleanValue = constraintInput(value);

				if (value !== undefined && value !== cleanValue) {
					modelCtrl.$setViewValue(cleanValue);
					modelCtrl.$render();
				}         

				return parseInput(value);
			}

			modelCtrl.$parsers.push(parser);
			modelCtrl.$formatters.push(formatter);

			element.on('blur', function() {

				$scope.$apply(function() {
					
					if (modelCtrl.$modelValue) {

						modelCtrl.$setValidity('date', true);
						modelCtrl.$setViewValue( formatValue(modelCtrl.$modelValue) );
						modelCtrl.$render();

					} else {
						modelCtrl.$setValidity('date', false);
					}
				});
			});
		}
	};
}])

;